<template>
  <Card class="engineer">
    <Row :gutter="8" class="ivu-row-flex my-0">
      <Col>
        <div class="rel mt-1">
          <div class="avatar" :style="{backgroundImage: `url(${so_user_img})`}"></div>
          <div class="so_user_name">{{so_user_name}}</div>
        </div>
      </Col>
      <Col span="18" ref="rightCol" class="so_user_txt">
        <Row class>
          <Col class="text-center" span="6">
            <img class="vm" src="@/assets/images/user.png" width="22" />
          </Col>
          <Col span="14">{{so_user_id ? so_user_id :'&nbsp,'}}</Col>
          <Col span="4">
            <div class="circle-btn fr bg-dell-primary">
              <a href="javascript:void(0);" @click="routeToLocation">
                <img width="22" src="@/assets/images/location.png" />
              </a>
            </div>
          </Col>
        </Row>
        <Row>
          <Col class="text-center" span="6">
            <img class="vm" src="@/assets/images/phone.png" width="22" />
          </Col>
          <Col span="14">
            <span>{{so_user_phone | phoneMask}}</span>
          </Col>
          <Col span="4">
            <div class="circle-btn fr bg-dell-primary" style="top:10px">
              <a :href="`tel:${so_user_phone}`">
                <img
                  class="vm"
                  width="26"
                  src="@/assets/images/contact.png"
                  style="margin-top: 8px; margin-left: 8px;"
                />
              </a>
            </div>
          </Col>
        </Row>
        <Row>
          <Col class="text-center" span="6">
            <img class="vm" src="@/assets/images/award.png" width="22" />
          </Col>
          <Col span="18">{{so_technical_field}}</Col>
        </Row>
      </Col>
    </Row>
    <Row class="my-0">
      <Col>
        <Divider class="my-0 mt-0"></Divider>
        <div style="text-align: center;">
          <Rate disabled v-model="so_evaluate" />
        </div>
      </Col>
    </Row>
  </Card>
</template>
<script>
import { getToken } from '@/assets/js/Util'

export default {
  props: ['data'],
  data () {
    return {
      so_no: '',
      so_no_des: '',
      so_user_id: '',
      so_user_name: '',
      so_user_phone: '',
      so_evaluate: 5,
      so_technical_field: '',
      so_user_img: '',
      colHeight: 0

    }
  },
  filters: {
    phoneMask (value) {
      if (value.length === 11) {
        value = value.replace(/^(\d{4})\d*(\d{3})$/g, '$1****$2')
      }

      return value
    }
  },
  watch: {
    data (newV, oldV) {
      this.so_no = newV.SO_NO
      this.so_no_des = newV.SO_NO_DES // 加密 so
      this.so_user_id = newV.SO_USER_ID
      this.so_user_name = newV.SO_USER_NAME
      this.so_user_phone = newV.SO_USER_PHONE

      if (newV.SO_USER_IMG === '') {
        this.so_user_img = require('@/assets/images/avatar.png')
        // this.so_user_img = require('@/assets/images/ava.jpg')
      } else {
        this.so_user_img = 'data:image/jpeg;base64,' + newV.SO_USER_IMG
      }
      this.so_evaluate = parseInt(newV.SO_EVALUATE, 10)
      this.so_technical_field = newV.SO_TECHNICAL_FIELD
    }
  },
  mounted () {
    // 获取右侧工程师信息 dom 的高度
    this.colHeight = this.$refs.rightCol.$el.offsetHeight - 10
  },
  computed: {
    // 根据工程师信息 dom 的高度动态计算工程师照片宽高
    avatar () {
      return {
        width: this.colHeight + 'px',
        height: this.colHeight + 'px',
        borderRadius: this.colHeight / 2 + 'px'
      }
    }
  },
  methods: {
    routeToLocation () {
      let status = this.data.SO_STATUS

      if (this.data.SO_ISHOW_MAP) {
        getToken(token => {
          this.$http
            .get(process.env.VUE_APP_API, {
              params: {
                type: 'get_location',
                so_no: this.so_no_des,
                source: this.data.Source !== '' ? this.data.Source : 'Customer',
                token
              }
            })
            .then(resp => {
              let data = resp.data
              if (resp.status === 200 && data.CODE === 'OK') {
                this.$router.push({
                  name: 'location',
                  query: {
                    so_no: this.so_no_des
                  }
                })
              } else {
                this.$Message.error({ content: data.MSG })
              }
            })
        })
      } else {
        switch (status) {
          case 'X':
            this.showModal('服务单已取消')
            break
          case 'C':
            this.showModal('服务单已完成')
            break
          case 'A':
            this.showModal('工程师已到达')
            break
          case 'O':
            this.showModal(
              '工程师出发后，可在此处查看他的实时位置信息；请在预约上门时间前1小时左右再查看，谢谢！'
            )
            break
        }
      }
    },
    showModal (content) {
      this.$Modal.info({
        content
      })
    }
  }
}
</script>

<style scoped>
.avatar {
  width: 72px;
  height: 72px;
  border-radius: 50%;
  border: 0.5px solid #ccc;
  background-size: cover;
}
.so_user_img {
  width: 72px;
  border-radius: 8px;
}
.so_user_txt {
  flex: 1;
  margin-left: 3px;
}
.so_user_name {
  /* font-size: 14px;
    line-height: 14px;
    position: absolute;
    top: 56px;
    text-align: center;
    background: rgba(0, 118, 206,0.7);
    width: 100%;
    color: #ffffff;
    padding: 3px 0; */
  text-align: center;
  font-size: 14px;
  line-height: 14px;
  margin-top: 7px;
}
</style>
